const RESEND_KEY = "re_eRECnMMS_ESUv5SZ1Q5z3VpxTDD929fjT";

export async function sendNotificationEmail({to, subject, html}) {
  console.log("SENDING EMAIL TO:", to, "SUBJECT:", subject);
  try {
    const response = await fetch("https://jgaxzpsnbgnmzfrybhdy.supabase.co/functions/v1/send-email", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpnYXh6cHNuYmdubXpmcnliaGR5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg1MjExOTYsImV4cCI6MjA5NDA5NzE5Nn0.1TOF4-levdAG6M2-zN-vDk4t0QbiLYnWqvKHMPNR1IY`
      },
      body: JSON.stringify({to, subject, html})
    });
    const data = await response.json();
    console.log("RESEND RESPONSE:", data);
    return data;
  } catch(e) {
    console.error("Email error:", e);
  }
}

export function commentEmailHTML(commenterName, postTitle, commentText) {
  return `
    <div style="font-family:Georgia,serif;max-width:600px;margin:0 auto;background:#FFFCF4;padding:32px;border-radius:12px;">
      <div style="text-align:center;margin-bottom:24px;">
        <h1 style="font-family:Georgia,serif;color:#2C1E0E;font-size:24px;">My Testimony</h1>
      </div>
      <p style="color:#2C1E0E;font-size:16px;">Someone commented on your testimony!</p>
      <div style="background:#F5EDD8;border-radius:8px;padding:16px;margin:16px 0;">
        <p style="color:#b45309;font-size:13px;margin:0 0 8px;"><strong>${commenterName}</strong> commented on <strong>${postTitle}</strong>:</p>
        <p style="color:#5A3E28;font-size:15px;font-style:italic;margin:0;">"${commentText}"</p>
      </div>
      <a href="https://mytestimonyapp.com" style="display:inline-block;background:#2C1E0E;color:#FFFCF4;padding:12px 24px;border-radius:20px;text-decoration:none;font-size:14px;margin-top:16px;">View Your Testimony</a>
      <p style="color:#A89070;font-size:12px;margin-top:24px;">You are receiving this because someone interacted with your testimony on My Testimony.</p>
    </div>
  `;
}

export function likeEmailHTML(likerName, postTitle) {
  return `
    <div style="font-family:Georgia,serif;max-width:600px;margin:0 auto;background:#FFFCF4;padding:32px;border-radius:12px;">
      <div style="text-align:center;margin-bottom:24px;">
        <h1 style="font-family:Georgia,serif;color:#2C1E0E;font-size:24px;">My Testimony</h1>
      </div>
      <p style="color:#2C1E0E;font-size:16px;">Someone liked your testimony! ❤️</p>
      <div style="background:#F5EDD8;border-radius:8px;padding:16px;margin:16px 0;">
        <p style="color:#b45309;font-size:13px;margin:0;"><strong>${likerName}</strong> liked your testimony <strong>${postTitle}</strong></p>
      </div>
      <a href="https://mytestimonyapp.com" style="display:inline-block;background:#2C1E0E;color:#FFFCF4;padding:12px 24px;border-radius:20px;text-decoration:none;font-size:14px;margin-top:16px;">View Your Testimony</a>
      <p style="color:#A89070;font-size:12px;margin-top:24px;">You are receiving this because someone interacted with your testimony on My Testimony.</p>
    </div>
  `;
}

export function followEmailHTML(followerName) {
  return `
    <div style="font-family:Georgia,serif;max-width:600px;margin:0 auto;background:#FFFCF4;padding:32px;border-radius:12px;">
      <div style="text-align:center;margin-bottom:24px;">
        <h1 style="font-family:Georgia,serif;color:#2C1E0E;font-size:24px;">My Testimony</h1>
      </div>
      <p style="color:#2C1E0E;font-size:16px;">You have a new follower! 👥</p>
      <div style="background:#F5EDD8;border-radius:8px;padding:16px;margin:16px 0;">
        <p style="color:#b45309;font-size:13px;margin:0;"><strong>${followerName}</strong> is now following you</p>
      </div>
      <a href="https://mytestimonyapp.com" style="display:inline-block;background:#2C1E0E;color:#FFFCF4;padding:12px 24px;border-radius:20px;text-decoration:none;font-size:14px;margin-top:16px;">View Your Profile</a>
      <p style="color:#A89070;font-size:12px;margin-top:24px;">You are receiving this because someone interacted with your testimony on My Testimony.</p>
    </div>
  `;
}

export function reportEmailHTML(reporterName, reason, details, postTitle) {
  return `
    <div style="font-family:Georgia,serif;max-width:600px;margin:0 auto;background:#FFF1F2;padding:32px;border-radius:12px;">
      <h2 style="color:#dc2626;font-family:Georgia,serif;">⚠️ Content Report</h2>
      <p style="color:#2C1E0E;"><strong>Reporter:</strong> ${reporterName}</p>
      <p style="color:#2C1E0E;"><strong>Post:</strong> ${postTitle}</p>
      <p style="color:#2C1E0E;"><strong>Reason:</strong> ${reason}</p>
      ${details?`<p style="color:#2C1E0E;"><strong>Details:</strong> ${details}</p>`:""}
      <p style="color:#991B1B;font-size:13px;margin-top:24px;">Please review this content on your Supabase dashboard.</p>
    </div>
  `;
}